// exportExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

export async function handleExportExcel(selectedRows, rows) {
   console.log(selectedRows)
   console.log(rows)

  if (!selectedRows || selectedRows.length === 0) {
    alert("กรุณาเลือกรายการที่ต้องการก่อน");
    return;
  }

  const selectedData = rows.filter((row) => selectedRows.includes(row.id));
  console.log("✅ selectedData:", selectedData);

  if (selectedData.length === 0) {
    alert("ไม่พบข้อมูลที่ตรงกับที่เลือก");
    return;
  }

  // โหลด template (วางไฟล์ MaterialRequest.xlsx ไว้ใน public/)
  const response = await fetch("/MaterialRequest_test.xlsx");
  const arrayBuffer = await response.arrayBuffer();

  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(arrayBuffer);

  const worksheet = workbook.worksheets[0];

  const headerRowNumber = 9;
  const headerRow = worksheet.getRow(headerRowNumber);

  const headerMap = {};
  headerRow.eachCell((cell, colNumber) => {
    if (cell.value) {
      headerMap[cell.value.toString().trim()] = colNumber;
    }
  });

  let startRow = headerRowNumber + 1;
  while (worksheet.getRow(startRow).getCell(1).value) {
    worksheet.spliceRows(startRow, 1);
  }
  let flattenedRows = [];

  selectedData.forEach((row) => {
    if (row.transactions && row.transactions.length > 0) {
      row.transactions.forEach((tx) => {
        flattenedRows.push({
          pickedUpCode: row.pickedUpCode,
          sku: tx.items?.[0]?.productCode,
          name: tx.items?.[0]?.productName,
          isPickedUp: row.isPickedUp,
          material_code: tx.material_code || tx.materialId, // ปรับตาม key ที่ได้มา
          totalWeight: tx.weightUsed || tx.totalWeight || 0,
        });
      });
    } else {
      // ถ้าไม่มี transaction ก็ใช้ row ปกติ
      flattenedRows.push(row);
    }
  });

  // ✍️ เติมข้อมูลใหม่ใน Excel
  flattenedRows.forEach((row, index) => {
    const rowNumber = startRow + index;
    const templateRow = worksheet.getRow(startRow - 1); // แถวตัวอย่าง format
    const excelRow = worksheet.getRow(rowNumber);
  
    // ใส่ค่า
    excelRow.getCell(headerMap["No."]).value = index + 1;
    excelRow.getCell(headerMap["Batch no."]).value = row.pickedUpCode;
    excelRow.getCell(headerMap["Material code"]).value = row.material_code;
    excelRow.getCell(headerMap["SKU"]).value = row.sku;
    excelRow.getCell(headerMap["ชื่อสินค้า"]).value = row.name;
    excelRow.getCell(headerMap["จำนวน"]).value = row.totalWeight.toLocaleString();
    excelRow.getCell(headerMap["หน่วย"]).value = "Kgs";
    excelRow.getCell(headerMap["สถานที่จัดส่ง"]).value = row.isPickedUp ? "S5" : "S2";
    excelRow.getCell(headerMap["หมายเหตุ"]).value = "";
  
    // คัดลอกเฉพาะ border, font, alignment ไม่เอา fill
    templateRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      const newCell = excelRow.getCell(colNumber);
      newCell.border = cell.border;
      // newCell.font = cell.font;
      newCell.alignment = cell.alignment;
      // newCell.fill = cell.fill; // ❌ ไม่เอา fill
    });
  
    excelRow.commit();
  });
  
  

  // อัปเดตวันที่ในแถว 2
  worksheet.getCell("K7").value = `${moment().format("D/MM/YYYY")}`;
  worksheet.getCell("K1").value = `เลขที่ WH1-${moment().format("YYYYMMDD")}`;

  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      if (
        cell.value &&
        cell.value.toString().trim().startsWith("แผนก Warehouse")
      ) {
        const nextRow = worksheet.getRow(row.number + 1);
        nextRow.getCell(1).value = `${moment().format("D/MM/YYYY")}`;
        nextRow.alignment = { horizontal: "center", vertical: "middle" };
        nextRow.commit();
      }
    });
  });
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      if (cell.value && typeof cell.value === "string") {
        const text = cell.value.toString().trim();
        if (text.includes("แผนก Production")) {
          const nextRow = worksheet.getRow(row.number + 1);
          const targetCell = nextRow.getCell("K");
          targetCell.value = moment().format("D/MM/YYYY");
          targetCell.alignment = { horizontal: "center", vertical: "middle" };
          nextRow.commit();
        }
      }
    });
  });

  // ดาวน์โหลดไฟล์ใหม่
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Material Request Form.xlsx");
}
